import { lazy } from "react";
import { Navigate } from "react-router";

// project imports
import MinimalLayout from "../layout/MinimalLayout";
import Loadable from "./../components/Loadable";
import NotFound from "../views/404";
import { getDefaultRoute } from "../config/routeConfig";

// auth routing
const AuthLogin = Loadable(lazy(() => import("../views/login/index")));
const AuthPosLogin = Loadable(
  lazy(() => import("../views/pos_dashboard/posLogin"))
);

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/login",
      element: <AuthLogin />,
    },
    {
      path: "pos/login",
      element: <AuthPosLogin />,
    },
    {
      path: "/",
      element: getRedirectElement(),
    },
    // Catch-all for unmatched authentication routes
    {
      path: "*",
      element: <NotFound />,
    },
  ],
};

function getRedirectElement() {
  const hostname = window.location.hostname;
  const isPosHost =
    hostname === "pos.dejlah.net" || hostname === "pos-test.dejlah.net";
  const token = localStorage.getItem("token");

  // Already authenticated: skip the login page and go straight to the home
  // page (e.g. when the app is opened in a new tab).
  if (token) {
    if (isPosHost) {
      return <Navigate to="/pos/external-orders" />;
    }
    const role = localStorage.getItem("role");
    const target = getDefaultRoute(role ? [role] : []);
    if (target && target !== "/login") {
      return <Navigate to={target} />;
    }
  }

  if (isPosHost) {
    return <Navigate to="/pos/login" />;
  }
  // Default redirect
  return <Navigate to="/login" />;
}

export default AuthenticationRoutes;
